<template>
  <!-- Ilustrações do painel amarelo das telas de autenticação (copiadas dos protótipos v3) -->
  <svg class="auth-ilustracao" viewBox="0 0 340 240" fill="none" aria-hidden="true">
    <!-- Login: título sendo protocolado e baixado -->
    <g v-if="nome === 'titulo'">
      <rect x="70" y="20" width="200" height="200" rx="16" fill="#fff"/>
      <rect x="96" y="50" width="88" height="10" rx="5" fill="#003668"/>
      <rect x="96" y="72" width="140" height="8" rx="4" fill="#FFE680"/>
      <rect x="96" y="90" width="120" height="8" rx="4" fill="#FFE680"/>
      <rect x="96" y="122" width="148" height="1.5" fill="#e2e8f0"/>
      <rect x="96" y="138" width="56" height="8" rx="4" fill="#cbd5e1"/>
      <rect x="196" y="134" width="48" height="16" rx="8" fill="#0052A0"/>
      <rect x="96" y="162" width="72" height="8" rx="4" fill="#cbd5e1"/>
      <rect x="196" y="158" width="48" height="16" rx="8" fill="#F27C00"/>
      <circle cx="262" cy="196" r="34" fill="#003668"/>
      <path d="M247 196l10 10 20-20" stroke="#FFD400" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
      <rect x="22" y="58" width="64" height="40" rx="10" fill="#FFA900"/>
      <rect x="34" y="70" width="40" height="6" rx="3" fill="#fff"/>
      <rect x="34" y="82" width="26" height="6" rx="3" fill="#fff"/>
    </g>

    <!-- Cadastro: ficha de conta com botão "+" -->
    <g v-else-if="nome === 'cadastro'">
      <rect x="70" y="20" width="200" height="200" rx="16" fill="#fff"/>
      <circle cx="120" cy="66" r="22" fill="#FFE680"/>
      <rect x="152" y="54" width="88" height="10" rx="5" fill="#003668"/>
      <rect x="152" y="72" width="60" height="8" rx="4" fill="#cbd5e1"/>
      <rect x="96" y="112" width="148" height="22" rx="6" fill="#fff" stroke="#e2e8f0" stroke-width="1.5"/>
      <rect x="96" y="144" width="148" height="22" rx="6" fill="#fff" stroke="#e2e8f0" stroke-width="1.5"/>
      <rect x="96" y="178" width="96" height="20" rx="6" fill="#0052A0"/>
      <circle cx="262" cy="196" r="34" fill="#003668"/>
      <path d="M262 182v28M248 196h28" stroke="#FFD400" stroke-width="6" stroke-linecap="round"/>
      <rect x="22" y="58" width="64" height="40" rx="10" fill="#FFA900"/>
      <rect x="34" y="70" width="40" height="6" rx="3" fill="#fff"/>
      <rect x="34" y="82" width="26" height="6" rx="3" fill="#fff"/>
    </g>

    <!-- E-mail: envelope com check -->
    <g v-else-if="nome === 'email'">
      <rect x="50" y="50" width="240" height="160" rx="16" fill="#fff"/>
      <path d="M62 66l108 76 108-76" stroke="#FFE680" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
      <rect x="96" y="160" width="100" height="8" rx="4" fill="#cbd5e1"/>
      <rect x="96" y="176" width="70" height="8" rx="4" fill="#cbd5e1"/>
      <circle cx="262" cy="196" r="34" fill="#003668"/>
      <path d="M247 196l10 10 20-20" stroke="#FFD400" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
      <rect x="18" y="20" width="64" height="40" rx="10" fill="#FFA900"/>
      <rect x="30" y="32" width="40" height="6" rx="3" fill="#fff"/>
      <rect x="30" y="44" width="26" height="6" rx="3" fill="#fff"/>
    </g>

    <!-- Senha: campo mascarado, barra de força e cadeado -->
    <g v-else-if="nome === 'senha'">
      <rect x="70" y="20" width="200" height="200" rx="16" fill="#fff"/>
      <rect x="96" y="50" width="88" height="10" rx="5" fill="#003668"/>
      <rect x="96" y="84" width="148" height="34" rx="8" fill="#fff" stroke="#e2e8f0" stroke-width="1.5"/>
      <circle cx="116" cy="101" r="5" fill="#003668"/>
      <circle cx="134" cy="101" r="5" fill="#003668"/>
      <circle cx="152" cy="101" r="5" fill="#003668"/>
      <circle cx="170" cy="101" r="5" fill="#003668"/>
      <circle cx="188" cy="101" r="5" fill="#003668"/>
      <rect x="96" y="134" width="34" height="6" rx="3" fill="#15803d"/>
      <rect x="134" y="134" width="34" height="6" rx="3" fill="#15803d"/>
      <rect x="172" y="134" width="34" height="6" rx="3" fill="#15803d"/>
      <rect x="210" y="134" width="34" height="6" rx="3" fill="#e2e8f0"/>
      <rect x="96" y="160" width="72" height="8" rx="4" fill="#cbd5e1"/>
      <circle cx="262" cy="196" r="34" fill="#003668"/>
      <rect x="250" y="192" width="24" height="18" rx="4" fill="#FFD400"/>
      <path d="M255 192v-6a7 7 0 0 1 14 0v6" stroke="#FFD400" stroke-width="4" fill="none"/>
      <rect x="22" y="58" width="64" height="40" rx="10" fill="#FFA900"/>
      <rect x="34" y="70" width="40" height="6" rx="3" fill="#fff"/>
      <rect x="34" y="82" width="26" height="6" rx="3" fill="#fff"/>
    </g>

    <!-- Empresa: lista com um item selecionado -->
    <g v-else-if="nome === 'empresa'">
      <rect x="90" y="16" width="180" height="56" rx="12" fill="#fff" opacity=".7"/>
      <rect x="80" y="84" width="200" height="60" rx="12" fill="#fff" stroke="#0052A0" stroke-width="3"/>
      <circle cx="106" cy="114" r="9" fill="#0052A0"/>
      <circle cx="106" cy="114" r="4" fill="#fff"/>
      <rect x="126" y="102" width="100" height="10" rx="5" fill="#003668"/>
      <rect x="126" y="120" width="70" height="8" rx="4" fill="#cbd5e1"/>
      <rect x="90" y="156" width="180" height="56" rx="12" fill="#fff" opacity=".7"/>
      <circle cx="112" cy="44" r="8" fill="none" stroke="#cbd5e1" stroke-width="3"/>
      <rect x="130" y="40" width="80" height="8" rx="4" fill="#cbd5e1"/>
      <circle cx="112" cy="184" r="8" fill="none" stroke="#cbd5e1" stroke-width="3"/>
      <rect x="130" y="180" width="80" height="8" rx="4" fill="#cbd5e1"/>
      <circle cx="262" cy="196" r="34" fill="#003668"/>
      <path d="M252 196h20M264 186l10 10-10 10" stroke="#FFD400" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "AuthIlustracao",
  props: {
    /** 'titulo' | 'cadastro' | 'email' | 'senha' | 'empresa' */
    nome: { type: String, default: "titulo" },
  },
};
</script>
